// Module
var code = `<ng-form name="\$ctrl.form">

  <dynamic-list
    ng-if="!\$ctrl.isDeviceEdited"
    columns="\$ctrl.columns"
    data="[\$ctrl.device]">
  </dynamic-list>

  <device-details
    device="\$ctrl.device"
    ng-if="\$ctrl.isDeviceEdited">
  </device-details>

  <div class="clearfix"></div>

  <div class="buttons"
       ng-if="\$ctrl.isDeviceEdited">
    <button
      class="btn btn-warning"
      ng-click="\$ctrl.cancel()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.save()">
      Save
    </button>
  </div>

  <validator condition="\$ctrl.isDeviceValid()"></validator>
</ng-form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/details/devices/new-agent-devices.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;